import { render, staticRenderFns } from "./phyDetail.vue?vue&type=template&id=7d52ccdd&scoped=true&title=%E9%A2%84%E7%BA%A6%E8%AF%A6%E6%83%85%E9%A1%B5-%E7%94%A8%E6%88%B7&"
import script from "./phyDetail.vue?vue&type=script&lang=js&"
export * from "./phyDetail.vue?vue&type=script&lang=js&"
import style0 from "./phyDetail.vue?vue&type=style&index=0&id=7d52ccdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d52ccdd",
  null
  
)

export default component.exports